import { useEffect } from "react";

export default function usePageMeta(title, description, noindex = false) {
  useEffect(() => {
    document.title = title;
    const set = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    if (description) set("description", description);
    set("robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, noindex]);
}
